"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utiliser sur des composants (input, output, etc) qui peuvent être masqués par des prédicats.
 *
 * Il faut mettre v-if="displayConditionOk" sur l'élément racine
 */
exports.default = {
    props: ["displayConditions"],
    data: function data() {
        return {
            listPredicateResult: null
        };
    },
    methods: {
        getPredicateResult: function getPredicateResult() {
            if (this.listPredicateResult === null) {
                var listPredicateResult = {};
                if (this.displayConditions) {
                    for (var _i = 0, _a = this.displayConditions; _i < _a.length; _i++) {
                        var condition = _a[_i];
                        listPredicateResult[condition] = false;
                    }
                }
                this.$set(this, "listPredicateResult", listPredicateResult);
            }
            return this.listPredicateResult;
        },
        setPredicateResult: function setPredicateResult(name, value) {
            if (name in this.listPredicateResult) {
                this.$set(this.listPredicateResult, name, value);
            }
        }
    },
    computed: {
        displayConditionOk: function displayConditionOk() {
            var res = this.getPredicateResult();
            return Object.keys(res).every(function (e) {
                return res[e];
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Workflow/Mixins/ConditionalDisplay.ts
// module id = 14
// module chunks = 0